<template>
  <v-app style="font-size: 13px">
    
    <v-app-bar 
      app 
      fixed 
      v-if="auth" 
      color="white" 
      :style="auth ? 'box-shadow: 0 1px 0 rgba(0,0,0,.15) !important' : 'box-shadow: 0 0 10px #fff'"
    >
      <div 
        class="d-flex align-center justify-space-between"
        style="width: 100vw; height: 100%; overflow: hidden; z-index: 300" 
        :class="auth ? 'auth-header' : ''"
      >
        
        <v-img 
          v-if="auth && auth?.whitelabel?.w?.enabled" 
          alt="The Media Trade" 
          class="shrink mt-0 mr-2" 
          contain
          min-width="57" 
          src="@/assets/logo-latam.svg" 
          width="127"
        />
        <router-link to="/app/home">
          <v-img 
            v-if="auth && !auth?.whitelabel?.w?.enabled && $vuetify.breakpoint.width >= 500" 
            alt="The Media Trade"
            class="shrink mt-0 mr-2" 
            contain 
            min-width="216" 
            src="@/assets/logo-cdv.svg" 
            width="127"
          />
          <v-img 
            v-if="auth && !auth?.whitelabel?.w?.enabled && $vuetify.breakpoint.width < 500" 
            alt="The Media Trade"
            class="shrink mt-0 mr-2" 
            contain 
            src="@/assets/favicon-cdv.png" 
            width="40"
          />
        </router-link>

        
        <template v-if="showWhitelabelNav">
          
          <AppStoreSelector
            :master-store="masterStore"
            :selected-store="selectedStore"
            :all-stores="allStores"
            :store-id="storeId"
            :has-whitelabel-id="hasWhitelabelId"
            @select-store="getStoreId"
          />
          <v-divider class="mx-0" vertical />

          <v-btn elevation="0" to="/dashboard/" color="white" tile>
            {{ $t("header.generalDescription") }}
          </v-btn>
          <v-divider class="mx-0" vertical />

          <v-tooltip bottom v-if="!hasWhitelabelId">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" tile class="mx-0" width="64" elevation="0" small to="/settings" color="white">
                <v-icon>mdi-brush</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("header.customization") }}</span>
          </v-tooltip>
          <v-divider class="mx-0" vertical v-if="!hasWhitelabelId" />

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" disabled v-on="on" tile class="mx-0" width="64" elevation="0" small color="white" to="/reports">
                <v-icon>mdi-file-chart</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("header.report") }}</span>
          </v-tooltip>
          <v-divider class="mx-0" vertical />

          
          <v-menu offset-y class="d-flex">
            <template v-slot:activator="activeMenu">
              <v-btn color="white" elevation="0" v-bind="activeMenu.attrs" v-on="activeMenu.on" tile class="mx-0 pa-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" style="width: 100%; height: 64px;" class="d-flex justify-center align-center">
                      <v-icon>mdi-apps</v-icon>
                    </div>
                  </template>
                  <span>{{ $t("header.app") }}</span>
                </v-tooltip>
              </v-btn>
            </template>
            
            
            <template v-if="auth?.whitelabel?.w?.enabled">
              <v-btn elevation="0" to="/products/asus" color="white" tile>
                {{ $t("headerMenu.products.title") }}
              </v-btn>
              <v-divider class="mx-0" vertical />

              <v-card class="px-2 py-4" max-width="900">
                <div class="d-flex">
                  <v-card elevation="0" class="pa-4 d-flex align-start" to="/products/asus" style="flex: 1 1 33%">
                    <v-icon color="primary" size="32">mdi-package-variant-closed</v-icon>
                    <div class="pl-2 pt-0" style="flex: 1 1 100%">
                      <div class="primary--text text-body-1 font-weight-medium pb-1">
                        {{ $t("headerMenu.products.title") }}
                      </div>
                      <v-card-subtitle style="padding: 0px">
                        {{ $t("headerMenu.products.subtitle") }}
                      </v-card-subtitle>
                    </div>
                  </v-card>
                  <v-card elevation="0" class="pa-4 d-flex align-start" to="/sales/orders" style="flex: 1 1 33%">
                    <v-icon color="primary" size="32">mdi-cart-check</v-icon>
                    <div class="pl-2 pt-0" style="flex: 1 1 100%">
                      <div class="primary--text text-body-1 font-weight-medium pb-1">
                        {{ $t("headerMenu.sales.title") }}
                      </div>
                      <v-card-subtitle style="padding: 0px">
                        {{ $t("headerMenu.sales.subtitle") }}
                      </v-card-subtitle>
                    </div>
                  </v-card>
                  <v-card v-if="!hasWhitelabelId" elevation="0" class="pa-4 d-flex align-start" to="/all-stores" style="flex: 1 1 33%">
                    <v-icon color="primary" size="32">mdi-storefront-outline</v-icon>
                    <div class="pl-2 pt-0" style="flex: 1 1 100%">
                      <div class="primary--text text-body-1 font-weight-medium pb-1">
                        {{ $t("headerMenu.stores.title") }}
                      </div>
                      <v-card-subtitle style="padding: 0px">
                        {{ $t("headerMenu.stores.subtitle") }}
                      </v-card-subtitle>
                    </div>
                  </v-card>
                </div>
                <div class="d-flex">
                  <v-card elevation="0" class="pa-4 d-flex align-start" style="flex: 1 1 33%" to="/marketing-and-seo/promotions">
                    <v-icon color="primary" size="32">mdi-bullhorn-variant-outline</v-icon>
                    <div class="pl-2 pt-0" style="flex: 1 1 100%">
                      <div class="text-body-1 primary--text font-weight-medium pb-1 d-flex justify-space-between">
                        {{ $t("headerMenu.Mkt&SEO.title") }}
                      </div>
                      <v-card-subtitle style="padding: 0px">
                        {{ $t("headerMenu.Mkt&SEO.subtitle") }}
                      </v-card-subtitle>
                    </div>
                  </v-card>
                  <v-card elevation="0" class="pa-4 d-flex align-start" style="flex: 1 1 33%" to="/financial/promotions">
                    <v-icon color="primary" size="32">mdi-finance</v-icon>
                    <div class="pl-2 pt-0" style="flex: 1 1 100%">
                      <div class="text-body-1 primary--text font-weight-medium pb-1 d-flex justify-space-between">
                        {{ $t("headerMenu.finantial.title") }}
                      </div>
                      <v-card-subtitle style="padding: 0px">
                        {{ $t("headerMenu.finantial.subtitle") }}
                      </v-card-subtitle>
                    </div>
                  </v-card>
                  <v-card v-if="!hasWhitelabelId" elevation="0" class="pa-4 d-flex align-start" style="flex: 1 1 33%" to="/integrations">
                    <v-icon color="primary" size="32">mdi-connection</v-icon>
                    <div class="pl-2 pt-0" style="flex: 1 1 100%">
                      <div class="text-body-1 primary--text font-weight-medium pb-1 d-flex justify-space-between">
                        {{ $t("headerMenu.api.title") }}
                      </div>
                      <v-card-subtitle style="padding: 0px">
                        {{ $t("headerMenu.api.subtitle") }}
                      </v-card-subtitle>
                    </div>
                  </v-card>
                </div>
              </v-card>
            </template>

            <template v-else>
              

              <v-btn elevation="0" :to="`/products/asus`" color="white" v-if="auth" tile>{{
                $t("headerMenu.products.title")
              }}</v-btn>
              <v-divider class="mx-0" vertical v-if="auth"></v-divider>

              <v-btn elevation="0" :to="`/sales/orders`" color="white" v-if="auth" tile>{{ $t("headerMenu.sales.title")
              }}</v-btn>
              <v-divider class="mx-0" vertical v-if="auth"></v-divider>

              <v-btn elevation="0" :to="`/all-stores`" color="white" v-if="auth && !$root.auth?.profile?.whitelabelId"
                tile>{{
                  $t("headerMenu.stores.title") }}</v-btn>
              <v-divider class="mx-0" vertical v-if="auth && !$root.auth?.profile?.whitelabelId"></v-divider>

              <v-btn elevation="0" :to="`/marketing-and-seo/promotions`" color="white" v-if="auth" tile>{{
                $t("headerMenu.Mkt&SEO.title") }}</v-btn>
              <v-divider class="mx-0" vertical v-if="auth"></v-divider>

              <v-btn elevation="0" :to="`/financial/promotions`" color="white" v-if="auth" tile>{{
                $t("headerMenu.finantial.title")
              }}</v-btn>
              <v-divider class="mx-0" vertical v-if="auth"></v-divider>

              <v-btn elevation="0" :to="`/integrations`" color="white" v-if="auth && !$root.auth?.profile?.whitelabelId"
                tile>{{
                  $t("headerMenu.api.title") }}</v-btn>
              <v-divider class="mx-0" vertical v-if="auth && !$root.auth?.profile?.whitelabelId"></v-divider>
            </template>

          </v-menu>

          <v-divider class="mx-0" vertical v-if="auth"></v-divider>

          <v-divider class="mx-0" vertical v-if="auth"></v-divider>
          <v-spacer></v-spacer>

          <v-divider class="mx-0" vertical> </v-divider>


          <template v-if="auth?.whitelabel?.w?.enabled">
            <v-divider class="mx-0" vertical> </v-divider>

            <v-btn color="white" to="/guide" class="mx-0" tile elevation="0">{{ $t("header.guide") }}
            </v-btn>
            <v-divider class="mx-0" vertical> </v-divider>
            <v-btn color="white" elevation="0" class="mx-0" tile
              href="https://wa.me/5511988729007?text=Olá,%20gostaria%20de%20ajuda%20com%20a%20plataforma%20Canal%20do%20Veiculo."
              target="_blank"><v-icon class="mr-2">mdi-whatsapp</v-icon> {{ $t("header.support") }}
            </v-btn> 
          </template>
          <v-btn v-else color="white" to="/help" class="mx-0" tile elevation="0">Ajuda</v-btn>
          <v-divider class="mx-0" vertical></v-divider>

            <v-btn to="/notifications" color="white" tile class="mx-0" width="64" elevation="0" small>
              <v-icon>mdi-bell-outline</v-icon>
            </v-btn>
          
          <v-divider vertical class="ml-0 mr-1"></v-divider>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn fab elevation="0" color="white" v-bind="attrs" v-on="on"><v-img :src="langs[$i18n.locale]"
                  height="20" width="30" contain></v-img>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(lang, i) in langs" :key="i" @click="changeLang(i)">
                <v-list-item-title class="d-flex align-center"><v-img :src="lang" height="14" width="21" class="mr-3"
                    contain></v-img><span style="text-transform: uppercase">{{ i }}</span></v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-divider class="mx-0" vertical v-if="auth"> </v-divider>

          <v-btn color="white" class="mx-0 d-flex align-center" tile elevation="0" @click="handleSwitchClick"
            style="padding: 0 16px; height: 100%; min-height: 64px;">

            <v-icon class="mx-2">mdi-swap-horizontal</v-icon>
          </v-btn>

          <v-divider class="mx-0" vertical></v-divider>
        </template>



        <template v-if="$route.path.includes('/app/') || $route.query.hasOwnProperty('cdv')">
          <v-divider class="mx-0" vertical> </v-divider>


          <v-btn elevation="0" :to="`/app/home`" color="white" tile class="mx-0 home-btn" width="64">
            <v-icon class="text--primary">mdi-home</v-icon>
          </v-btn>
          <v-divider class="mx-0" vertical> </v-divider>


          <template v-if="$vuetify.breakpoint.width >= 1370">
            <v-btn to="/app/management/home" color="white" class="mx-0 nav-btn" tile elevation="0">
              <v-icon class="mr-2">mdi-domain</v-icon>
              Gestão
            </v-btn>

            <v-divider class="mx-0" vertical></v-divider>


            <v-btn to="/app/comercial/quotations" color="white" class="mx-0 nav-btn" tile elevation="0">
              <v-icon class="mr-2">mdi-human-male-board-poll</v-icon>
              Comercial
            </v-btn>
            <v-divider class="mx-0" vertical></v-divider>

            <v-btn to="/app/inventory/formats" color="white" class="mx-0 nav-btn" tile elevation="0">
              <v-icon class="mr-2">mdi-package-variant-closed</v-icon>
              Inventário
            </v-btn>
            <v-divider class="mx-0" vertical></v-divider>

            <v-btn disabled color="white" class="disabled-btn mx-0" tile elevation="0">
              <v-icon class="mr-2">mdi-finance</v-icon>
              Financeiro
            </v-btn>
            <v-divider class="mx-0" vertical></v-divider>



            <v-btn disabled color="white" class="disabled-btn mx-0" tile elevation="0"
              v-if="!$root.auth?.profile?.whitelabelId">
              <v-icon class="mr-2">mdi-crown-outline</v-icon>
              Premium
            </v-btn>
            <v-divider class="mx-0" vertical v-if="!$root.auth?.profile?.whitelabelId"></v-divider>
          </template>


          <template v-else>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="white" class="mx-0" tile elevation="0" v-bind="attrs" v-on="on" width="64">
                  <v-icon>mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item to="/app/management/home">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-domain</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Gestão</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item to="/app/comercial/quotations">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-human-male-board-poll</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Comercial</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider class="my-1"></v-divider>

                <v-list-item disabled>
                  <v-list-item-icon>
                    <v-icon>mdi-finance</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Financeiro</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item to="/app/inventory/formats">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-package-variant-closed</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Inventário</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item disabled v-if="!$root.auth?.profile?.whitelabelId">
                  <v-list-item-icon>
                    <v-icon>mdi-crown-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Premium</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider class="my-1"></v-divider>

                <v-list-item to="/app/help">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-help-circle-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Ajuda</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item to="/app/notifications">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-bell-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Notificações</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider class="my-1"></v-divider>

                <v-list-item v-if="!auth?.whitelabel?.w?.enabled" @click="openWhiteLabelModal">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-store</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="text-wrap">Ative sua loja própria</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-else @click="handleSwitchClick">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-swap-horizontal</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Alternar modo</v-list-item-title>
                    <v-list-item-subtitle class="text-caption">Loja própria ⇄ Marketplace</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-divider class="mx-0" vertical></v-divider>
          </template>

          <v-divider v-if="$vuetify.breakpoint.width >= 1000" class="mx-0" vertical> </v-divider>

          <v-spacer></v-spacer>

          <v-divider v-if="$vuetify.breakpoint.width >= 1000" class="mx-0" vertical> </v-divider>

          <v-btn v-if="$vuetify.breakpoint.width >= 1000" color="white" to="/app/help" class="mx-0" tile
            elevation="0">Ajuda
          </v-btn>
          <v-divider v-if="$vuetify.breakpoint.width >= 1000" class="mx-0" vertical> </v-divider>

          <v-menu v-if="$vuetify.breakpoint.width >= 1000" v-model="notificationMenu" offset-y :close-on-content-click="false" max-width="420" min-width="380">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" color="white" tile class="mx-0" width="64" elevation="0" small>
                <div class="notification-bell-wrapper">
                  <v-badge
                    v-if="quotationNotificationCount > 0"
                    :content="quotationNotificationCount"
                    color="amber darken-1"
                    overlap
                    offset-x="-16"
                    offset-y="-4"
                  >
                    <span></span>
                  </v-badge>
                  <v-badge
                    :content="notificationCount"
                    :value="hasNotifications"
                    color="red"
                    overlap
                    offset-x="10"
                    offset-y="39"
                  >
                    <v-icon>{{ hasAnyNotifications ? 'mdi-bell-ring-outline' : 'mdi-bell-outline' }}</v-icon>
                  </v-badge>
                </div>
              </v-btn>
            </template>
            
            <v-card class="notification-menu-card">
              <v-card-title class="d-flex justify-space-between align-center py-2 px-4" style="background: #f5f5f5;">
                <span class="text-subtitle-1 font-weight-medium">Notificações</span>
                <div class="d-flex align-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon small @click="refreshAllNotifications" :loading="notificationsLoading || quotationNotificationsLoading">
                        <v-icon small>mdi-refresh</v-icon>
                      </v-btn>
                    </template>
                    <span>Atualizar</span>
                  </v-tooltip>
                </div>
              </v-card-title>
              
              <v-divider></v-divider>
              
              <v-list v-if="hasAnyNotifications" class="py-0 notification-list" style="max-height: 400px; overflow-y: auto;">
                <v-list-item
                  v-for="notification in allNotificationsSorted"
                  :key="notification.id"
                  :to="notification.route"
                  @click="notificationMenu = false"
                  class="notification-item notification-item--divided"
                >
                  <v-list-item-avatar size="40">
                    <v-icon :color="notification.color" size="24">{{ notification.icon }}</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-body-2 font-weight-medium" style="white-space: normal; line-height: 1.3;">
                      {{ notification.title }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-caption mt-1" style="white-space: normal; line-height: 1.3;">
                      {{ notification.message }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon small color="grey">mdi-chevron-right</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              
              <v-list v-else class="py-0">
                <v-list-item>
                  <v-list-item-content class="text-center py-8">
                    <v-icon size="48" color="grey lighten-1" class="mb-3">mdi-bell-check-outline</v-icon>
                    <v-list-item-title class="text-body-2 grey--text">
                      Tudo certo por aqui!
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-caption grey--text text--lighten-1 mt-1">
                      Você não tem notificações pendentes
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>

          <v-divider v-if="$vuetify.breakpoint.width >= 1000" class="mx-0" vertical> </v-divider>

          <template v-if="$vuetify.breakpoint.width >= 1000">
            <v-btn v-if="!auth?.whitelabel?.w?.enabled"
              class=" d-flex flex-column text--primary align-center justify-center"
              style="background: white; text-align: center; border-radius: 0px; font-weight: bold;" elevation="0"
              @click="openWhiteLabelModal">
              <span>Ative sua loja própria de mídia</span>
            </v-btn>

            <v-btn v-else color="white" class="mx-0 d-flex align-center" tile elevation="0" @click="handleSwitchClick"
              style="padding: 0 16px; height: 100%; min-height: 64px;">
              <span class="mr-3">
                Loja própria
              </span>
              <v-icon class="mx-2">mdi-swap-horizontal</v-icon>
              <span class="ml-3">Marketplace</span>
            </v-btn>
          </template>

          <v-divider v-if="$vuetify.breakpoint.width >= 1000" class="mx-0" vertical> </v-divider>

        </template>
        <v-btn v-if="auth" fab color="grey lighten-3" class="ml-3" elevation="0" @click="menu = !menu">


          <v-avatar v-if="auth" width="48" height="48">
            <v-img :src="getLogo()" alt="" width="48" contain />
          </v-avatar>
        </v-btn>
      </div>
    </v-app-bar>

    <v-app-bar fixed v-else color="white"
      :style="auth ? `box-shadow: 0 1px 0 rgba(0,0,0,.15) !important` : `box-shadow: 0 0 10px #fff`">
      <router-link :to="'/'">
        <v-img v-if="!$root.isMobile" alt="Canal do Anúncio" class="shrink mt-0" contain min-width="57"
          src="@/assets/logo-latam.svg" width="120"></v-img>


        <v-img v-else alt="Canal do Anúncio" class="shrink mt-0" contain min-width="57" src="@/assets/logo-old.svg"
          width="40"></v-img>

      </router-link>
      <v-spacer></v-spacer>

      <div v-if="!$root.isMobile" class="d-flex justify-center align-center">
        <router-link :to="'/'">
          <v-img alt="The Media Trade" class="shrink mt-0 mr-2 logo-cdv-center" contain min-width="57"
            src="@/assets/logo-cdv.svg" width="270"></v-img>
        </router-link>
      </div>

      <v-spacer></v-spacer>
      <v-btn elevation="0" v-if="!auth && !$root.isMobile" text to="/whitelabel">White label</v-btn>
      <v-btn class="text-center" elevation="0" v-else text to="/whitelabel">White <br> label</v-btn>
      <v-btn elevation="0" text to="/entrar" v-if="!auth">{{
        $t("header.login")
        }}</v-btn>
      <v-btn elevation="0" class="mx-2" to="/cadastrar" color="primary" v-if="!auth">{{ $t("header.signup") }}</v-btn>
      <v-divider class="mx-0" vertical v-if="auth"> </v-divider>

       <v-btn to="/notifications" color="white" width="64" v-if="auth" elevation="0" small>
          <v-icon>mdi-bell-outline</v-icon>
        </v-btn>

      <v-divider vertical class="ml-0 mr-1" v-if="auth"></v-divider>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="!$root.isMobile" fab elevation="0" color="white" v-bind="attrs" v-on="on"><v-img
              :src="langs[$i18n.locale]" height="20" width="30" contain></v-img>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(lang, i) in langs" :key="i" @click="changeLang(i)">
            <v-list-item-title class="d-flex align-center"><v-img :src="lang" height="14" width="21" class="mr-3"
                contain></v-img><span style="text-transform: uppercase">{{
                  i
                }}</span></v-list-item-title>
          </v-list-item>

        </v-list>
      </v-menu>
      <v-divider class="mx-0" vertical v-if="auth"> </v-divider>

      <v-btn v-if="auth" fab color="grey lighten-3" class="ml-3" elevation="0" @click="menu = !menu">


        <v-avatar>
          <img :src="auth.profile.logo" alt="" width="48" contain />
        </v-avatar>
      </v-btn>
    </v-app-bar>
    <v-main>
      <div v-if="!$root.loading">
        <router-view :key="$route.fullPath" />
        <AuthFooter v-if="auth"></AuthFooter>
      </div>
      <div v-else>
        <div class="text-center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
      </div>
    </v-main>
    <v-navigation-drawer v-model="menu" v-if="$root.isMobile || auth" fixed temporary right>
      <v-list-item v-if="auth">
        <v-list-item-avatar>
          <v-img :src="auth.profile.logo" width="48" height="48"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ auth.profile.displayName }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="$root.isMobile" to="/whitelabel">
        <v-list-item-content>
          <v-list-item-title>White label</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-if="$root.isMobile && auth?.whitelabel?.w?.enabled" to="/dashboard">
        <v-list-item-content>
          <v-list-item-title>White label</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider v-if="auth"></v-divider>

      <v-list>
        <template v-for="(item, index) in dynamicItems">

          <v-list-item :key="index" link
            :to="item.icon === 'mdi-cog' && auth?.whitelabel?.w?.enabled && $route.path.includes('/app') ? null : item.to"
            @click="item.icon === 'mdi-cog' && auth?.whitelabel?.w?.enabled && $route.path.includes('/app') ? handleAccountClick(item.to) : null"
            v-if="item.icon !== 'mdi-cog' || auth?.whitelabel?.w?.enabled">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <SnackBar rer="SnackBar" />



    <WhiteLabelModal v-model="showWhiteLabelModal" />


    <v-dialog v-model="showConfirmationDialog" max-width="400">
      <v-card>
        <v-card-title class="text-h6">
          Confirmação
        </v-card-title>
        <v-card-text>
          {{ confirmationText }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="showConfirmationDialog = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" @click="navigateToSwitch">
            Sim, continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <a v-if="$route.params.p == 'bgs'" href="https://wa.me/5511952502187" target="_blank"
      style="position: fixed; top: calc(100vh - 80px); right: 20px;">
      <svg width="60" height="60" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle class="color-element" cx="19.4395" cy="19.4395" r="19.4395" fill="#49E670"></circle>
        <path
          d="M12.9821 10.1115C12.7029 10.7767 11.5862 11.442 10.7486 11.575C10.1902 11.7081 9.35269 11.8411 6.84003 10.7767C3.48981 9.44628 1.39593 6.25317 1.25634 6.12012C1.11674 5.85403 2.13001e-06 4.39053 2.13001e-06 2.92702C2.13001e-06 1.46351 0.83755 0.665231 1.11673 0.399139C1.39592 0.133046 1.8147 1.01506e-06 2.23348 1.01506e-06C2.37307 1.01506e-06 2.51267 1.01506e-06 2.65226 1.01506e-06C2.93144 1.01506e-06 3.21063 -2.02219e-06 3.35022 0.532183C3.62941 1.19741 4.32736 2.66092 4.32736 2.79397C4.46696 2.92702 4.46696 3.19311 4.32736 3.32616C4.18777 3.59225 4.18777 3.59224 3.90858 3.85834C3.76899 3.99138 3.6294 4.12443 3.48981 4.39052C3.35022 4.52357 3.21063 4.78966 3.35022 5.05576C3.48981 5.32185 4.18777 6.38622 5.16491 7.18449C6.42125 8.24886 7.39839 8.51496 7.81717 8.78105C8.09636 8.91409 8.37554 8.9141 8.65472 8.648C8.93391 8.38191 9.21309 7.98277 9.49228 7.58363C9.77146 7.31754 10.0507 7.1845 10.3298 7.31754C10.609 7.45059 12.2841 8.11582 12.5633 8.38191C12.8425 8.51496 13.1217 8.648 13.1217 8.78105C13.1217 8.78105 13.1217 9.44628 12.9821 10.1115Z"
          transform="translate(12.9597 12.9597)" fill="#FAFAFA"></path>
        <path
          d="M0.196998 23.295L0.131434 23.4862L0.323216 23.4223L5.52771 21.6875C7.4273 22.8471 9.47325 23.4274 11.6637 23.4274C18.134 23.4274 23.4274 18.134 23.4274 11.6637C23.4274 5.19344 18.134 -0.1 11.6637 -0.1C5.19344 -0.1 -0.1 5.19344 -0.1 11.6637C-0.1 13.9996 0.624492 16.3352 1.93021 18.2398L0.196998 23.295ZM5.87658 19.8847L5.84025 19.8665L5.80154 19.8788L2.78138 20.8398L3.73978 17.9646L3.75932 17.906L3.71562 17.8623L3.43104 17.5777C2.27704 15.8437 1.55796 13.8245 1.55796 11.6637C1.55796 6.03288 6.03288 1.55796 11.6637 1.55796C17.2945 1.55796 21.7695 6.03288 21.7695 11.6637C21.7695 17.2945 17.2945 21.7695 11.6637 21.7695C9.64222 21.7695 7.76778 21.1921 6.18227 20.039L6.17557 20.0342L6.16817 20.0305L5.87658 19.8847Z"
          transform="translate(7.7758 7.77582)" fill="white" stroke="white" stroke-width="0.2"></path>
      </svg>
    </a>

    <global-snackbar ref="globalSnackbar" />
  </v-app>
</template>
<script>
import GlobalSnackbar from '@/components/globalComponents/GlobalSnackbar.vue'
import { setSnackbarInstance } from '@/plugins/snackbar-helper'
import { mapGetters, mapActions, mapState } from "vuex";
import { initializeApp } from "firebase/app";
import moment from "moment";
import SnackBar from "@/components/globalComponents/SnackBar.vue";
import AuthFooter from "./components/AuthFooter.vue";
import WhiteLabelModal from "@/components/dialogs/WhiteLabelModal.vue";
import AppStoreSelector from "@/components/home/AppStoreSelector.vue";
import { getAuth, getAuthToken } from '@/services/authService'

export default {
  name: "App",
  components: { 
    AuthFooter, 
    SnackBar, 
    WhiteLabelModal, 
    GlobalSnackbar,
    AppStoreSelector
  },

  data: () => ({
    loadingmenu: true,
    SnackBar: null,
    storeId: "",
    preventLoading: false,
    selected: [],
    menu: false,
    notificationMenu: false,
    showWhiteLabelModal: false,
    showConfirmationDialog: false,
    pendingAccountNavigation: null,
    langs: {
      "en-US": require("@/assets/images/countries/en-US.svg"),
      "pt-BR": require("@/assets/images/countries/pt-BR.svg"),
      "es-PE": require("@/assets/flags/per.svg"),
    },
    get auth() {
      return getAuth()
    },
    items: [

      {
        title: "navDrawer.accountTitle",
        icon: "mdi-cog",
        to: "/account/whitelabel",
        active: true,
      },
      {
        title: "navDrawer.myaccountTitle",
        icon: "mdi-account-outline",
        to: "/conta/configuracoes/dados-pessoais",
        active: true,
      },
      {
        title: "navDrawer.exitTitle",
        icon: "mdi-logout",
        to: "/sair",
        active: true,
      },
    ],
    store: [
      {
        title: "Cotações",
        icon: "mdi-format-list-text",
        to: "/cotacoes",
      },
      {
        title: "Conta",
        icon: "mdi-cog",
        to: "/conta",
      },
      {
        title: "Sair",
        icon: "mdi-logout",
        to: "/sair",
      },
    ],
  }),
  watch: {
    storeId: {
      deep: true,
      handler(nv) {
        this.getSelectedStore(nv);
      },
    },

    auth: {
      deep: true,
      handler(nv, ov) {
        if (ov == null && nv) {
          this.getAllStores(this.$root.auth);
        }
        this.preventLoading = true;
        setTimeout(() => {
          this.preventLoading = false;
        }, 100);
      },
    },
    '$route.fullPath': {
      handler() {
        this.updateBodyRoute()
        this.updatePageTitle()

        if (this.auth) {
          this.refreshAllNotifications()
        }
      }
    }
  },
  async created() {
    if (this.auth) {
      if (this.$root.auth?.profile?.whitelabelId) {
        this.items[0].active = false
      }
      this.loadingmenu = false


      this.$root.loading = true;
      await this.getAllStores(this.$root.auth);
      this.getMasterStore();
      this.getSubStores();
      this.getSelectedStore(false);
      
      this.fetchAllNotifications();
    }

    const localeDefault = this.$i18n.locale ? this.$i18n.locale : "en-US";
    let locale = this.getCookie("TMT[lang]");
    if (locale == "pt") {
      locale = "pt-BR";
    }
    if (locale) {
      if (locale != localeDefault) {
        this.changeLang(locale);
        this.$locale = moment.locale(locale.toLowerCase());
        this.$vuetify.lang.current = this.$locale.split("-")[0];
      }
    } else {
      this.changeLang(localeDefault);
      this.$locale = moment.locale(localeDefault.toLowerCase());
      this.$vuetify.lang.current = this.$locale.split("-")[0];
    }
  },

  mounted() {
    if (this.$route.fullPath == '/cadastrar?p=bgs') {
      this.$router.replace('/cadastrar/bgs')
    }
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    setTimeout(() => {
      this.checkSession()
    }, 1000)
    this.updateBodyRoute()
    this.updatePageTitle()

    if (this.$refs.globalSnackbar) {
      setSnackbarInstance(this.$refs.globalSnackbar)
    }
  },

  beforeDestroy() {
    if (typeof window === "undefined") return;
    window.removeEventListener("resize", this.onResize, { passive: true });
  },

  computed: {
    ...mapState("groupStores", [
      "allStores",
      "masterStore",
      "subStores",
      "selectedStore",
    ]),
    ...mapState("notifications", {
      notifications: "notifications",
      quotationNotifications: "quotationNotifications",
      notificationsLoading: "loading",
      quotationNotificationsLoading: "quotationLoading",
      notificationsTestMode: "testMode",
    }),

    hasWhitelabelId() {
      return !!this.$root.auth?.profile?.whitelabelId;
    },

    showWhitelabelNav() {
      return this.auth?.whitelabel?.w?.enabled && 
             this.$route.path !== '/welcome' && 
             !this.$route.path.includes('/app/') && 
             !this.$route.query.hasOwnProperty('cdv');
    },

    showAppNav() {
      return this.$route.path.includes('/app/') || this.$route.query.hasOwnProperty('cdv');
    },

    isDesktop() {
      return this.$vuetify.breakpoint.width >= 1370;
    },

    isTabletOrLarger() {
      return this.$vuetify.breakpoint.width >= 1000;
    },

    notificationCount() {
      return this.$store.getters['notifications/notificationCount']
    },

    quotationNotificationCount() {
      return this.$store.getters['notifications/quotationNotificationCount']
    },

    hasNotifications() {
      return this.$store.getters['notifications/hasNotifications']
    },

    hasQuotationNotifications() {
      return this.$store.getters['notifications/hasQuotationNotifications']
    },

    hasAnyNotifications() {
      return this.$store.getters['notifications/hasAnyNotifications']
    },

    allNotificationsSorted() {
      return this.$store.getters['notifications/allNotificationsSorted']
    },

    styling() {
      if (this.dark) return "background: #233a75; height: 70px";
      else return "background: none; height: 70px";
    },

    switchRoute() {
      return this.$route.path === '/app/home' ? '/dashboard' : '/app/home';
    },

    confirmationText() {
      if (this.pendingAccountNavigation) {
        return 'Deseja continuar para as configurações da sua conta no painel de gestão da loja própria?';
      } else if (this.$route.path.includes('/app')) {
        return 'Deseja continuar para o painel de gestão da sua loja própria?';
      } else {
        return 'Deseja continuar para o painel de gestão do seu veículo no Canal do Anúncio e Canal do Mídia?';
      }
    },

    dynamicItems() {
      const isFromApp = this.$route.path.includes('/app') || this.$route.query.hasOwnProperty('cdv');
      return this.items.map(item => {
        if (item.title === "navDrawer.myaccountTitle") {
          return {
            ...item,
            to: isFromApp ? "/conta/configuracoes/dados-pessoais?cdv" : "/conta/configuracoes/dados-pessoais"
          };
        }
        return item;
      });
    },
  },

  methods: {
    ...mapActions("groupStores", [
      "getAllStores",
      "getMasterStore",
      "getSubStores",
      "getSelectedStore",
    ]),
    ...mapActions("notifications", [
      "fetchNotifications",
      "refreshNotifications",
      "fetchQuotationNotifications",
      "refreshQuotationNotifications",
      "fetchAllNotifications",
      "refreshAllNotifications",
      "setTestMode",
    ]),
    getLogo() {
      if (this.auth.profile.logo.includes('lion-web-site')) {
        return this.auth.profile.logo
      } else {
        let logo = ''
        for (const key in this.auth.profiles) {
          const profile = this.auth.profiles[key]

          if (profile.logo.includes('lion-web-site')) {
            logo = profile.logo
          }
        }

        if (logo === '') {
          logo = this.auth.profile.logo
        }

        return logo
      }
    },
    checkSession() {
      clearTimeout(this._sessionTimer)
      const auth = getAuthToken()
      if (!auth) return

      this._sessionTimer = setTimeout(() => {
        this.$axios.get('users/whoiam').then(
          () => { this.checkSession() },
          (err) => {
            if (err && err.response && err.response.status === 401) {
              this.$router.replace({ name: 'Logout' })
            } else {
              this.checkSession()
            }
          }
        )
      }, 60000)
    },
    getStoreId(id) {
      this.storeId = id;
      this.$root.loading = true;
    },
    loadAccount() {
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const q = query(
        collection(db, "stores"),
        where("status", "in", ["published", "disabled", "review", "partner"])
      );
      const querySnapshot = getDocs(q);
      const stores = [];
      querySnapshot.then((docs) => {
        docs.forEach((doc) => {
          if (this.$root.auth?.profile?.whitelabelId) {

            if (doc.data().id == this.$root.auth?.profile?.whitelabelId) {
              this.master = doc.data();
              stores.push(doc.data());
            }
          }
          else {
            if (doc.data().master) {
              this.master = doc.data();
            }
            stores.push(doc.data());
          }
        });
        this.stores = stores;
        localStorage.setItem(
          "stores",
          JSON.stringify({ stores: stores, master: this.master })
        );
      });
    },
    onResize() {
      this.isMobile = window.innerWidth < 600;
    },
    changeLang(lang) {
      const lower = lang.toLowerCase();
      const firstLower = lower.split("-")[0];
      this.$i18n.locale = lang;
      this.$vuetify.lang.current = firstLower;
      moment.locale(lang.toLowerCase());
      this.$locale = firstLower;
      this.$root.locale = firstLower;

      this.setCookie("TMT[lang]", lang, 180);
    },
    setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    openWhiteLabelModal() {
      this.showWhiteLabelModal = true;
    },

    handleSwitchClick() {
      this.pendingAccountNavigation = null;
      this.showConfirmationDialog = true;
    },

    handleAccountClick(to) {
      this.pendingAccountNavigation = to;
      this.showConfirmationDialog = true;
    },

    navigateToSwitch() {
      this.showConfirmationDialog = false;

      if (this.pendingAccountNavigation) {
        this.$router.push(this.pendingAccountNavigation);
        this.pendingAccountNavigation = null;
      } else {
        this.$router.push(this.switchRoute);
      }
    },

    updateBodyRoute() {
      document.body.setAttribute('data-route', this.$route.path);
    },

    updatePageTitle() {
      const route = this.$route.path;
      let title = 'The Media Trade';

      const routeTitles = {
        '/app/management': 'The Media Trade - Gestão',
        '/app/management/users': 'The Media Trade - Gestão - Usuários',
        '/app/management/profiles': 'The Media Trade - Gestão - Dados Cadastrais',
        '/app/comercial': 'The Media Trade - Comercial',
        '/app/comercial/cotacoes': 'The Media Trade - Comercial - Cotações',
        '/app/home': 'The Media Trade - Home',
        '/dashboard': 'The Media Trade - Dashboard',
        '/conta': 'The Media Trade - Conta',
        '/cotacoes': 'The Media Trade - Cotações',
        '/entrar': 'The Media Trade - Entrar',
        '/cadastrar': 'The Media Trade - Cadastrar',
        '/guide': 'The Media Trade - Guia',
        '/help': 'The Media Trade - Ajuda',
        '/notifications': 'The Media Trade - Notificações',
        '/integrations': 'The Media Trade - Integrações',
        '/whitelabel': 'The Media Trade - White Label'
      };

      if (route.includes('/app/management/profiles/')) {
        title = 'The Media Trade - Gestão - Perfil';
      } else if (routeTitles[route]) {
        title = routeTitles[route];
      } else if (route.startsWith('/app/management')) {
        title = 'The Media Trade - Gestão';
      } else if (route.startsWith('/app/comercial')) {
        title = 'The Media Trade - Comercial';
      } else if (route.startsWith('/app/')) {
        title = 'The Media Trade - App';
      }

      document.title = title;
    },

    handleNotificationClick(notification) {
      this.notificationMenu = false;
      if (notification.route) {
        this.$router.push(notification.route);
      }
    },

    toggleTestMode() {
      this.setTestMode(!this.notificationsTestMode);
    },

    getNotificationIcon(type) {
      const icons = {
        'address': 'mdi-map-marker-alert-outline',
        'cadastral': 'mdi-account-alert-outline',
        'bank': 'mdi-bank-off-outline'
      };
      return icons[type] || 'mdi-alert-circle-outline';
    },

    getNotificationColor(type) {
      const colors = {
        'address': 'orange',
        'cadastral': 'red',
        'bank': 'amber darken-2'
      };
      return colors[type] || 'grey';
    }
  },
};
</script>

<style lang="scss">
.disabled-btn {
  background: #f2f2f2 !important;
  color: #bdbdbd !important;
  border: none !important;
}

*,
.v-application * {
  font-family: "Poppins", sans-serif !important;
  word-break: normal !important;

  .text-h1,
  .text-h2,
  .text-h3,
  .text-h4,
  .text-h5,
  .text-h6,
  .text-subtitle-1,
  .text-subtitle-2,
  .text-body-1,
  .text-body-2,
  .text-button,
  .text-caption,
  .text-overline {
    font-family: "Poppins", sans-serif !important;
    line-height: 1.25em;
  }
}

body[data-route^="/app"] *,
body[data-route^="/app"] .v-application * {
  font-family: "Roboto", sans-serif !important;
}

body[data-route^="/app"] .text-h1,
body[data-route^="/app"] .text-h2,
body[data-route^="/app"] .text-h3,
body[data-route^="/app"] .text-h4,
body[data-route^="/app"] .text-h5,
body[data-route^="/app"] .text-h6,
body[data-route^="/app"] .text-subtitle-1,
body[data-route^="/app"] .text-subtitle-2,
body[data-route^="/app"] .text-body-1,
body[data-route^="/app"] .text-body-2,
body[data-route^="/app"] .text-button,
body[data-route^="/app"] .text-caption,
body[data-route^="/app"] .text-overline {
  font-family: "Roboto", sans-serif !important;

  @media screen and (max-width: 960px) {
    .text-h1 {
      font-size: 3em !important;
      line-height: 1.15 !important;
    }
  }

  @media screen and (max-width: 768px) {
    .text-h2 {
      font-size: 3rem !important;
    }

    .text-h3 {
      font-size: 2.5rem !important;
    }
  }
}

header {
  max-height: 64px;
}

.v-main {
  flex: 1 1 100%;
  padding-top: 64px !important;
}

.v-btn {
  letter-spacing: normal !important;
  text-transform: none !important;
}

.hero {
  background: #000;
  min-height: 100vh;
  width: 100vw;
  max-width: 100vw;
  margin: 0;
  position: relative;
  margin: 0;
}

.logo {
  background: #233a75;
  width: 70px;
  height: 75px !important;
  border: none;
  padding: 0;
  min-width: 120px !important;

  &:before {
    background: none;
  }

  &.v-btn--active::before {
    opacity: 0 !important;
  }
}

.theme--light.v-application,
.theme--dark.v-application {
  background: none !important;
}

.v-footer {
  background: #233a75 !important;
}

.v-toolbar__content,
.v-toolbar__extension {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.vh-100 {
  min-height: 100vh;
}

.auth-header {
  >.v-btn:not(.v-btn--fab) {
    min-height: 64px;
  }
}

.v-subheader {
  height: 36px !important;
}

.v-list-item {
  min-height: 36px !important;
  font-size: 0.83em;
}

.v-list-item__action {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 8px;
}

.--menu {
  flex: 1 1 50%;
}

.sub-bar {
  .v-toolbar__content {
    height: 40px !important;
  }
}

.theme--light.v-sheet:not(.v-alert):not(.v-card) {
  border-color: rgba(0, 0, 0, 0.12) !important;
}

ol {
  counter-reset: item
}

ol li {
  display: block
}

ol li:before {
  content: counters(item, ".") " ";
  counter-increment: item
}

@media (max-width: 480px) {
  .auth-header {
    height: 56px !important;
    overflow: hidden;
  }
}


.home-btn {
  background: #fff !important;
  color: white !important;
  transition: background 0.2s;
}

.home-btn:hover {
  background: #f5f5f5 !important;
  color: #8f8f8f !important;
}

.nav-btn {
  color: #203a75 !important;
}

.nav-btn .v-icon {
  color: #203a75 !important;
}

.nav-btn.v-btn--active {
  color: #203a75 !important;
  background-color: rgba(12, 16, 46, 0.1) !important;
}

.nav-btn.v-btn--active .v-icon {
  color: #203a75 !important;
}

.v-data-table>.v-data-table__wrapper>table>tbody>tr>td,
.v-data-table>.v-data-table__wrapper>table>tbody>tr>th,
.v-data-table>.v-data-table__wrapper>table>thead>tr>td,
.v-data-table>.v-data-table__wrapper>table>thead>tr>th,
.v-data-table>.v-data-table__wrapper>table>tfoot>tr>td,
.v-data-table>.v-data-table__wrapper>table>tfoot>tr>th {
  padding: 0 6px !important;
}

.logo-cdv-center {
  margin-left: 257px;
}

@media (max-width: 1000px) {
  .logo-cdv-center {
    margin-left: 0;
  }
}

.notification-menu-card {
  border-radius: 8px !important;
  overflow: hidden;
}

.notification-bell-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notification-list {
  .notification-item {
    cursor: pointer;
    transition: background-color 0.2s ease;
    min-height: 72px !important;

    &:hover {
      background-color: #f5f5f5;
    }

    &--divided:not(:last-child) {
      border-bottom: thin solid rgba(0, 0, 0, 0.12);
    }
  }
}

.v-badge__badge {
  font-size: 10px !important;
  font-weight: 600;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
}

@keyframes bellRing {
  0%, 100% { transform: rotate(0); }
  10%, 30%, 50% { transform: rotate(10deg); }
  20%, 40% { transform: rotate(-10deg); }
  60% { transform: rotate(0); }
}

.notification-bell-active {
  animation: bellRing 1s ease-in-out;
}
</style>
